import { ProjectIntegrationType } from 'types'
import { assertNever } from 'utils/assertNever'
import jiraLogo from './assets/jira.png'
import flowLogo from './assets/flow.png'
import clickupLogo from './assets/clickup.png'
import workdayLogo from './assets/workday.png'

export const getIntegrationLogo = (
  integrationType: ProjectIntegrationType,
): string => {
  switch (integrationType) {
    case ProjectIntegrationType.Jira:
      return jiraLogo
    case ProjectIntegrationType.ShotGrid:
      return flowLogo
    case ProjectIntegrationType.Clickup:
      return clickupLogo
    default:
      return assertNever(integrationType)
  }
}

export { workdayLogo }
